import React, { useState } from "react";
import JoinusModel from '../../components/JoinusModel.jsx';
const Statement = () => {
    const [isJoinUsModelOpen,setIsJoinUsModelOpen] = useState(false);
    function joinUs() {
        setIsJoinUsModelOpen(true);
    }
    return (
        <>
            <div id="statement" className="flex justify-center lg-xl:mt-20 lg:mt-15 mt-10">
                <div className="relative w-full mx-auto overflow-hidden">
                    <img src="/banner.png" alt="Voters at polling station" className="w-full md:h-auto sm:h-[390px] h-[550px] object-cover block" />
                    
                    <div className="absolute inset-0 bg-[#00066A]/50 flex flex-col justify-center items-center text-center">
                        <div className="px-20px max-w-[1100px] mx-auto">
                            <h2 className="font-bold lg-xl:text-[40px] lg-xl:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] text-customRed tracking-normal uppercase font-fira pb-2.5">Mission Statement</h2>
                            <p className="text-white lg-xl:text-[26px] font-medium lg-xl:leading-[41.6px] text-[20px] leading-[24px] tracking-normal font-fira lg-xl:pb-30px pb-5">
                                The mission of Fired Up To Vote is to increase voter turnout in every election within Harris County.
                                Fired Up To Vote achieves this by offering a user-friendly software tool that empowers citizens to activate their friends and personal networks to vote.
                                Additionally, Fired Up To Vote strives to educate voters about upcoming elections, candidates, and pertinent issues, ultimately fostering the election of productive, 
                                common-sense, transparent leaders.
                            </p>
                            <span  className="bg-customRed lg-xl:max-w-[252px] max-w-[200px] lg-xl:py-20px py-2 mx-auto flex items-center justify-center text-white lg-xl:text-22px font-medium lg-xl:leading-[23.4px]  text-18px leading-[24px] tracking-normal font-fira uppercase hover:bg-darkRed cursor-pointer" onClick={joinUs}>
                                <img src="/vote.svg" alt="vote" />
                                <span className="pl-2.5 pr-[30px]">JOIN US</span>
                                <img src="/arrow_forward.svg" alt="arrow" />
                            </span>
                        </div>
                    </div>
                </div>       
            </div>
            {isJoinUsModelOpen && <JoinusModel closeModel={()=> setIsJoinUsModelOpen(false)}/> }
        </>
    );
};

export default Statement;